import { DrmConfig, StreamUrl } from '@interfaces/player.interface'
import { VelvetSDK } from 'sdk'

export const getVideoInfo = async (slug: string, lang: string) => {
  return VelvetSDK.CMS.service().fetchEntitlements(slug, lang)
}

export const reduceUrlByType = (elements: Array<StreamUrl | DrmConfig>, withLA?: boolean) =>
  elements?.reduce(
    (obj, { type, url }) =>
      Object.assign(obj, {
        [type.toLowerCase()]: withLA ? { LA_URL: url } : url,
      }),
    {},
  )

export const registerMediaControlKeys = () => {
  if (navigator.userAgent.match(/Tizen/i)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line no-undef
    typeof tizen !== 'undefined' && tizen.tvinputdevice.registerKeyBatch(['MediaPlay', 'MediaPause', 'MediaPlayPause'])
  }
}
